import { Modal, Button as AntButton, Select } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { addEmployeeCampus } from "../../../../api/employees.api";
import useAxios from "../../../../hooks/useAxios";
import { RootState } from "../../../../store/rootReducer";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  memberCode: string|undefined;
  campusList: any;
  campuses: string[];
  setCampuses: (campuses: string[]) => void;
}

const AddCampusModal: FC<IProps> = ({
  visible,
  setVisible,
  memberCode,
  campusList,
  campuses,
  setCampuses,
}) => {
  const { t } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();
  
  const [campusCode, setCampusCode] = useState('');
  const [campusData, setCampusData] = useState<any>([]);

  useEffect(() => {
    if (campusList?.length) {
      if (auth.hqYn === 'Y') {
        setCampusData(campusList);
      } else {
        setCampusData(campusList.filter((item: any) => auth.campus.includes(item.campusCode)));
      }
    }
  }, [campusList]);
  
  useEffect(() => {
    if (submitRes && submitIsLoading) {
      setCampuses([...campuses, campusCode]);
      setVisible(false);
    }
  }, [submitRes, submitIsLoading]);

  const onSubmit = () => {
    if (!memberCode || !campusCode) return;

    submitExecute(addEmployeeCampus(memberCode, { campusCode: [campusCode] }));
  };

  return (
    <>
      {submitIsLoading && <Loader />}
      <ErrorResponse error={submitError} />      
      <Modal
        title={t('campus.staff.button6')}
        visible={visible}
        onCancel={() => setVisible(false)}
        width={400}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={onSubmit}
            >
              {t('common.button.confirm')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="comm-bx__space">
          <div className="flex justify-content-center">
            <span className="text-md">{t('campus.staff.text5')}</span>
          </div>
        </div>
        <Select
          className="w-100"
          placeholder={t('campus.staff.placeholder2')}
          value={campusCode}
          onChange={value => setCampusCode(value)}
        >
          {campusData.map((campus: any) => (
            <Select.Option
              key={campus.campusCode}
              value={campus.campusCode}
            >
              {campus.campusKorName}
            </Select.Option>
          ))}
        </Select>      
      </Modal>
    </>
  );
};

export default AddCampusModal;
